export default {"src":"/_next/static/media/lighting.81fd3b4c.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};